<template>
  <div>
    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <b-card>
            <b-row>
              <!-- User Info: Left col -->
              <b-col
                cols="21"
                xl="6"
                class="d-flex justify-content-between flex-column"
              >
                <!-- User Avatar & Action Buttons -->
                <div class="d-flex justify-content-center">
                  <b-avatar
                    :src="userData.avatar"
                    :text="'FGL'"
                    size="300px"
                    rounded
                    style="background-color:#3F51B5;"
                  />
                </div>
                <!--
                <div class="d-flex justify-content-center mt-2">
                  <b-row>
                    <b-col sm="12">
                      <b-button class="btn-icon fixed-width" variant="primary">
                         <font-awesome-icon icon="fa-solid fa-pen-to-square" /> Edit
                      </b-button>
                      <b-button
                        class="btn-icon fixed-width ml-1"
                        variant="outline-danger"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" /> Delete
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                -->
                <!-- User Stats
                <div class="d-flex justify-content-center mt-2">
                  <div class="d-flex justify-content-center mr-2">
                    <b-avatar variant="light-primary" rounded>
                      <feather-icon icon="DollarSignIcon" size="18" />
                    </b-avatar>
                    <div class="ml-1">
                      <h5 class="mb-0">23.3k</h5>
                      <small>Monthly Sales</small>
                    </div>
                  </div>

                  <div class="d-flex justify-content-center">
                    <b-avatar variant="light-success" rounded>
                      <feather-icon icon="TrendingUpIcon" size="18" />
                    </b-avatar>
                    <div class="ml-1">
                      <h5 class="mb-0">$99.87k</h5>
                      <small>Annual Profit</small>
                    </div>
                  </div>
                </div>
                -->
              </b-col>

              <!-- Right Col: Table -->
              <b-col cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th class="pb-50">
                      <feather-icon icon="UserIcon" class="mr-75" />
                      <span class="font-weight-bold title-freight">Username</span>
                    </th>
                    <td class="pb-50">
                      {{ userData.username }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon icon="CheckIcon" class="mr-75" />
                      <span class="font-weight-bold title-freight">Status</span>
                    </th>
                    <td class="pb-50 text-capitalize">Active</td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon icon="StarIcon" class="mr-75" />
                      <span class="font-weight-bold title-freight">Role</span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{ userData.roles }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pb-50">
                      <feather-icon icon="SettingsIcon" class="mr-75" />
                      <span class="font-weight-bold title-freight">Departmart</span>
                    </th>
                    <td class="pb-50">{{ userData.department }}</td>
                  </tr>
                  <tr>
                    <th>
                      <feather-icon icon="PhoneIcon" class="mr-75" />
                      <span class="font-weight-bold title-freight">Contact</span>
                    </th>
                    <td>{{ userData.telno }}</td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>

          <!-- <user-view-user-info-card :user-data="userData" /> -->
        </b-col>
        <!-- <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-view-user-plan-card />
        </b-col> -->
      </b-row>
    </template>
  </div>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol, BAlert } from "bootstrap-vue";
import Service from "@/@API/cDropdown";
import UserService from "@/@API/cUser";
export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BAlert,
  },
  data() {
    return {
      isLoading: true,
      departmentOption: [],
      userData: {
        uid: localStorage.getItem("uid"),
        username: localStorage.getItem("username"),
        roles: localStorage.getItem("roles"),
        department:"",
        telno:"",
        avatar:
          "/demo/vuexy-vuejs-admin-dashboard-template/demo-2/img/13-small.d796bffd.png",
      },
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    getDefault() {
      let lang = localStorage.getItem("language");

      Service.getDepartmentDropdown({})
        .then((response) => {
          this.departmentOption = [];
          response.data.lstDepartment.forEach((cc) => {
            this.departmentOption.push(cc);
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });

      var dataFilter = {
        intUserId: this.userData.uid,
      };
      UserService.getSearchUser(dataFilter)
        .then((response) => { 
          this.userData.department = response.data[0].department;
          this.userData.telno = response.data[0].telno;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style>
.fixed-width {
  width: 100px;
}
</style>
